import * as React from 'react';

import './nav.scss';
import { LogoLinkDto } from '@api/dtos';
import { injectTSDI } from '../../core/tsdi';
import { CheckoutConfigStore } from '../../views/checkout/store';

interface NavProps {
    logoLink?: LogoLinkDto;
    logoImageUrl: string;
    navLinks?: React.ReactNode;
    children?: React.ReactNode;
}

const sanitizeHref = (href: string | undefined) => {
    if (href) {
        return href.includes('https://') || href.includes('http://')
            ? href
            : `https://${href}`;
    } else {
        return '';
    }
};

const resolveLinkUrl = (logoLink?: LogoLinkDto) => {
    const { url } = injectTSDI(CheckoutConfigStore);
    switch (logoLink?.type) {
        case 'URL':
            return sanitizeHref(logoLink?.url);
        case 'LOCATION_OVERVIEW':
            return url;
        case 'NONE':
        case undefined:
            return undefined;
    }
};

export const Nav = (props: NavProps) => {
    const { logoLink, logoImageUrl, navLinks, children } = props;
    const LogoImage = <img className="logo" src={logoImageUrl} />;
    return (
        <nav className="navigation">
            {navLinks}
            {logoLink?.type !== 'NONE' ? (
                <a rel="noreferrer noopener" href={resolveLinkUrl(logoLink)}>
                    {LogoImage}
                </a>
            ) : (
                LogoImage
            )}
            {children}
        </nav>
    );
};
